/**
 * The five retired addresses, sent on to their tab under `/prospects`.
 *
 * `/site-scanner`, `/scan-leads`, `/site-audits`, `/brain` and `/brain-due`
 * were pages for long enough to be in bookmarks, in browser history, in links
 * pasted into tasks and ticket replies, and in the handbook's own text. They
 * keep a route each in `CRM_ROUTES` (same permission as before, nested where
 * the old page had sub-paths) and every one of them mounts this component.
 *
 * The work is in `legacyTarget`, because the one thing this must not do is the
 * thing a bare `<Navigate>` does by default: drop `location.search`. The hash
 * rides along too, so an anchor into a long page still scrolls where it did.
 *
 * `replace`, so the old address does not stay in history for the back button
 * to bounce straight into the redirect again.
 */
import { Navigate, useLocation } from "react-router-dom";
import { HOME_STEP, legacyTarget, stepPath } from "./steps";

export function LegacyRedirect() {
  const { pathname, search, hash } = useLocation();
  // Null only if a route was mounted here for an address the table does not
  // know, which the nav test rules out; the home tab beats a blank screen.
  const target = legacyTarget(pathname, search) ?? stepPath(HOME_STEP);
  return <Navigate to={`${target}${hash}`} replace />;
}
